import { render, staticRenderFns } from "./CustomDriverAccountsDetail.vue?vue&type=template&id=13e4dafd&scoped=true&"
import script from "./CustomDriverAccountsDetail.vue?vue&type=script&lang=js&"
export * from "./CustomDriverAccountsDetail.vue?vue&type=script&lang=js&"
import style0 from "./CustomDriverAccountsDetail.vue?vue&type=style&index=0&id=13e4dafd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e4dafd",
  null
  
)

export default component.exports